import toast from "react-hot-toast";
import { clientRoutes } from "../routes";
import axiosInstance from "./Axios";

export class UserApi {
  static getInvitationsList = async ({
    page,
    search,
    inviter_id,
    invitation_status,
    invitee_user_type,
    duration_start_date,
    duration_end_date,
  }: {
    page: number;
    search: string;
    inviter_id: string;
    invitation_status: string;
    invitee_user_type: string;
    duration_start_date: string;
    duration_end_date: string;
  }) => {
    try {
      const res = await axiosInstance.get(`client/invitations`, {
        params: {
          page,
          limit: 20,
          created_at: "desc",
          search,
          inviter_id,
          invitation_status,
          invitee_user_type,
          invitation_type: "",
          duration_start_date,
          duration_end_date,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getUsers = async ({
    search,
    status,
    role,
    start_date,
    end_date,
    page,
  }: {
    search: string;
    status: string;
    role: string;
    start_date: string;
    end_date: string;
    page: number;
  }) => {
    try {
      const res = await axiosInstance.get(`admin/users`, {
        params: {
          search,
          status,
          role,
          start_date,
          end_date,
          page,
          limit: 30,
          created_at: "desc",
        },
      });
     

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      // if (status === 401) {
      //   toast.error("Unauthorized, please login!");
      //   window.location.href = clientRoutes.login;
      // }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static createUser = async (data: any) => {
    try {
      const res = await axiosInstance.post(`admin/users/store`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateUser = async ({
    user_id,
    data,
  }: {
    user_id: string;
    data: any;
  }) => {
    try {
      const res = await axiosInstance.post(
        `admin/users/update/${user_id}`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getUserByid = async (user_id: string) => {
    try {
      const res = await axiosInstance.get(`admin/users/${user_id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getInvitationsByid = async (invite_id: string) => {
    try {
      const res = await axiosInstance.get(`client/invitations/${invite_id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static sendInviteEmail = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `client/invitations/send-invite-on-email`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static sendInviteReminder = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `client/invitations/send-reminder`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static sendInviteResend = async (data: any) => {
    try {
      const res = await axiosInstance.post(`client/invitations/resend`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };
}
